import * as m from "mithril";
import { InternationalStringDTO } from "../apiclient/ApiDtos";
import './TopTabBar.scss'
import CustomSvgIcon, { CustomSvgIconType } from "./CustomSvgIcon";

interface Attrs {
    showAsShakeForNewFeatureTab : boolean;
    initialSelectedTabIndex: number;
    tabLabels: { label: string, iconType: CustomSvgIconType, isNewFeature?: boolean }[];
    onChange: (seletedTabIndex: number) => void;
}

export default function TopTabBar(): m.Component<Attrs> {
    let selectedIndex = 0;

    return {
        view(vnode) {
            selectedIndex = vnode.attrs.initialSelectedTabIndex;
            return m("div.top-tab-bar",
                vnode.attrs.tabLabels.map((it, index) =>
                    m("div.item", {
                        class: index == selectedIndex ? "item-active text-primary fw-bold" : "text-info_ text-muted",
                        onclick: (event) => {
                            selectedIndex = index;
                            vnode.attrs.onChange(selectedIndex);
                        }
                    }, [
                        m("span", m(CustomSvgIcon, {
                            iconType: it.iconType,
                            themeCssClass: index == selectedIndex ? "svg-info svg-small" : "svg-info svg-small"
                        })),
                        m("span.mx-2", m("small", it.label)),
                        it.isNewFeature === true && m("span.badge badge-danger badge-new", {
                            class: vnode.attrs.showAsShakeForNewFeatureTab? "greeting-shake" : ""
                        },"new")
                    ])
                )
            );
        }
    }
}
